// extracted by mini-css-extract-plugin
export default {"tagSelect":"index_tagSelect__TWLfA","option":"index_option__oy1Mo","active":"index_active__2xX4S"};